import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useGetBonusTemplateDetails = () => {
    const send = useGenericSend();

    return useCallback(
        async (request: Types.IGetBonusTemplateDetailsRequestData): Promise<Types.IGetBonusTemplateDetailsResponseData> => {
            const { data } = await send<Types.IGetBonusTemplateDetailsRequestData, Types.IGetBonusTemplateDetailsResponseData>({
                ID: 31079,
                responses: [31080, 31081],
                description: 'Get bonus template details',
                errorLevel: 1,
                ...request
            });

            return data;
        }, [
            send
        ]);
};
